import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  Button,
  ButtonGroup,
  VStack,
} from '@chakra-ui/react';
import { Formik } from 'formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BPCInput } from 'common/components/form/BPCInput';
import { BPCYup } from 'common/form.validation';
import { RoutePath } from 'router/routes.paths';
import { ChampionnatFirebase } from '../championnat.types';
import {
  createChampionnatPersonnalise,
  updateChampionnatPersonnalise,
} from '../championnat.api';
import { useConnectedUserContext } from 'features/user/useConnectedUserContext';

const ChampionnatPersonnaliseSchema = BPCYup.object().shape({
  name: BPCYup.string()
    .min(3, 'Le nom doit contenir au moins 3 caractères')
    .required(),
});

export default function NouveauChampionnatPersonnaliseForm({
  championnat,
  onCancel,
}: {
  championnat?: ChampionnatFirebase;
  onCancel?: () => void;
}) {
  const { user } = useConnectedUserContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  return (
    <Box pb={2}>
      <Formik
        initialValues={{ name: championnat?.name ?? '' }}
        validationSchema={ChampionnatPersonnaliseSchema}
        enableReinitialize
        onSubmit={async ({ name }) => {
          if (!user) return;
          setErrorMessage(undefined);
          setIsLoading(true);
          try {
            const id = championnat
              ? await updateChampionnatPersonnalise(
                  { ...championnat, name },
                  user.id,
                )
              : await createChampionnatPersonnalise(name, user.id);
            navigate(`${RoutePath.championnats}/${id}`);
          } catch (e: any) {
            setErrorMessage(e.message);
          }
          setIsLoading(false);
        }}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              {errorMessage && (
                <Alert status="error">
                  <AlertIcon />
                  <AlertDescription>{errorMessage}</AlertDescription>
                </Alert>
              )}
              <BPCInput fieldName="name" label="Nom" type="text" />
              <ButtonGroup gap={4} mt={4}>
                {onCancel && (
                  <Button width="full" onClick={onCancel} variant="outline">
                    Annuler
                  </Button>
                )}
                <Button isLoading={isLoading} type="submit" width="full">
                  {championnat
                    ? 'Modifier le championnat'
                    : 'Créer le championnat'}
                </Button>
              </ButtonGroup>
            </VStack>
          </form>
        )}
      </Formik>
    </Box>
  );
}
